import { FC, useEffect } from 'react'
import { useParams } from 'react-router'

import { monitorMessage } from '@/modules/monitoring'
import { NoAccessTemplate } from '@/modules/urlRouting/NoAccessTemplate'

/**
 * Terminal page for an org with no products enabled.
 *
 * Rendered instead of redirecting on purpose: when every landing page lookup
 * falls through there is nowhere to send the user, and the region routes end in
 * a catch-all that would bounce any redirect straight back here.
 */
export const NoProductAccessPage: FC = () => {
  const { regionId } = useParams()

  useEffect(() => {
    monitorMessage(
      'Org has no products enabled: every region landing page lookup fell through. ' +
        'Likely an org misconfiguration, e.g. none of the product flags on ' +
        'organizations.organization_settings are set.',
      { urlRegionId: regionId }
    )
  }, [regionId])

  return <NoAccessTemplate primaryText="No products are enabled for your organization" />
}
